module.exports = __webpack_public_path__ + "img/_54A6741.de3e2dcc.jpg";